import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import HelpButton from 'help/HelpButton';
import {InputChangeEvent} from 'util/Types';

import * as SpreadsheetBulkImportActions from './SpreadsheetBulkImportActions';

interface SpreadsheetBulkImportOptionProps {
  className?: string;
  helpContent?: JSX.Element;
  isChecked: boolean;
  isDisabled: boolean;
  name: string;
  // Optional onChange callback to set dependent data
  onChange?: (e: InputChangeEvent) => void;
  text: React.ReactNode;
}

export default function SpreadsheetBulkImportOption(props: SpreadsheetBulkImportOptionProps): JSX.Element {
  const handleChangeOption = (e: InputChangeEvent): void => {
    // If onChange is specified, allow caller to handle change.
    if (props.onChange) {
      props.onChange(e);
      return;
    }
    // Otherwise, default to updating option in store.
    SpreadsheetBulkImportActions.setOptions({[props.name]: e.target.checked});
  };

  return (
    <div className={classNames(props.className, css(styles.optionDiv))}>
      <label
        className={classNames('u-normal-font-weight', css(styles.optionLabel), {'u-faded': props.isDisabled})}
      >
        <input
          type="checkbox"
          disabled={props.isDisabled}
          onChange={handleChangeOption}
          checked={props.isChecked}
        />
        {props.text}
      </label>
      {props.helpContent && (
        <HelpButton renderContent={() => props.helpContent!} iconClassName="u-tiny-spacing-left" />
      )}
    </div>
  );
}

SpreadsheetBulkImportOption.defaultProps = {isDisabled: false};

const styles = StyleSheet.create({
  optionDiv: {
    display: 'flex',
  },
  optionLabel: {
    display: 'flex',
    alignItems: 'center',
  },
});
